// @flow

import { Map, fromJS } from 'immutable';

export const GET_PROFILE = 'App/profile/GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'App/profile/GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAIL = 'App/profile/GET_PROFILE_FAIL';
export const CLEAR_PROFILE_DATA = 'App/profile/CLEAR_PROFILE_DATA';

const initialState = Map({
  getProfileLoading: false,
  profileData: Map({}),
  getProfileFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_PROFILE:
      return state.merge({
        getProfileLoading: true,
        getProfileFail: null,
      });
    case GET_PROFILE_SUCCESS:
      return state.merge({
        getProfileLoading: false,
        profileData: fromJS(action.data),
      });
    case GET_PROFILE_FAIL:
      return state.merge({
        getProfileLoading: false,
        getProfileFail: fromJS(action.data),
      });
    case CLEAR_PROFILE_DATA:
      return state.set('profileData', Map({}));
    default:
      return state;
  }
};

export const getProfile = () => (dispatch : any) =>
  dispatch({ type: GET_PROFILE });
